import { DefaultModal } from 'components/Modals/DefaultModal';
import { SpecialStainsTable } from 'components/AntibodiesList/SpecialStainsTable';
import React, { useEffect, useState } from 'react';
import { getSpecialStainsIHC } from 'services/resources/commonResources';
import { FormInput } from 'components/FormInputs/FormInput';
import { Button, Box } from '@mui/material';
import { FETCH_SPECIAL_STAINS_ERROR } from 'components/OrderSlidesList/SlideActionTabs/constants';
import { useSnackbar } from 'utilities/hooks/useSnackbar/useSnackbar';

export const SpecialStainsModal = ({
  isSpecialStainsModalOpen,
  handleSpecialStainsModalClose,
  handleAddSpecialStain,
  classes,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [specialStains, setSpecialStains] = useState([]);
  const [selectedStain, setSelectedStain] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState('');

  const { showError } = useSnackbar();

  useEffect(() => {
    setIsLoading(true);
    getSpecialStainsIHC()
      .then((stains) => {
        setSpecialStains(stains);
      })
      .catch(() => {
        showError(FETCH_SPECIAL_STAINS_ERROR);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleAdd = () => {
    handleAddSpecialStain(selectedStain);
    handleSpecialStainsModalClose();
  };

  const onQuickFilterText = (e) => {
    setQuickFilterText(e.target.value);
  };

  return (
    <DefaultModal
      open={isSpecialStainsModalOpen}
      onClose={handleSpecialStainsModalClose}
      title="Add Special Stain"
      styles={{ width: '80%', height: '80%' }}
    >
      <Box display="flex" justifyContent="space-between">
        <FormInput onChange={onQuickFilterText} value={quickFilterText} />
        <Button
          id="add-special-stain-button"
          onClick={handleAdd}
          className={classes.addToSlideButton}
          color="primary"
          disabled={!selectedStain}
        >
          Add to slide
        </Button>
      </Box>
      <Box data-nosnippet="true" className="ag-theme-balham" height="90%">
        <SpecialStainsTable
          rowData={specialStains}
          isLoading={isLoading}
          quickFilterText={quickFilterText}
          setSelectedStain={setSelectedStain}
        />
      </Box>
    </DefaultModal>
  );
};
